"use strict";

/**
 * Фильтр дат
 *
 * Хранит в себе один набор дат, выполняет по ним поиск
 * Поддерживает ежегодные даты
 */
(function(){

var self = Fotobook.HolidaysFilter = function(holidays){
    this.dates = {};

    if (holidays){
        this.setDates(holidays);
    }
};

$.extend(self.prototype, {
    REPEAT_NONE: 0,
    REPEAT_EVERY_YEAR: 1,
});

$.extend(self.prototype, {

    repeatOrder: [self.prototype.REPEAT_NONE, self.prototype.REPEAT_EVERY_YEAR],

    /** формирует ключ для поиска праздника по дате и параметру повторения */
    buildKey: function(date, repeat){
        if (!(date instanceof Date)) {
            date = new Date(date);
        }

        if (repeat === self.prototype.REPEAT_NONE) {
            return date.toNormalizedDateString();
        } else if (repeat === self.prototype.REPEAT_EVERY_YEAR) {
            return [date.getMonth() + 1, date.getDate()].join("-");
        }
        throw "Unknown repeat (" + repeat + ") type " + typeof repeat;
    },

    /** Индексирует праздники для поиска */
    reindexDates: function(dates){
        var newDates = {},
            key;

        for (var i=0, l=dates.length; i<l; i++) {
            key = this.buildKey(dates[i].date, dates[i].repeat);
            newDates[key] = dates[i];
        }
        return newDates;
    },

    /** Установка праздников */
    setDates: function(dates){
        if (typeof dates === "object"){
            dates = Object.values(dates).sort(function(a, b){
                return a.date.strnatcmp(b.date);
            });
        }
        this.dates = this.reindexDates(dates);
    },

    /** Получение праздников */
    getDates: function(){
        return Object.values(this.dates);
    },

    /** Получение подходящего объекта праздника по дате */
    getDate: function(date){
        var repeat, key, holiday;

        for (var i = 0; i < this.repeatOrder.length; i++) {
            if (!this.repeatOrder.hasOwnProperty(i)) {
                continue;
            }
            key = this.buildKey(date, this.repeatOrder[i]);
            holiday = this.dates[key];
            if (holiday) {
                return holiday;
            }
        }
        return null;
    },
});

})();
